import { useState } from "react";
import Logo from "assets/img/landing/logo.svg";
import ArabicLogo from "assets/img/landing/ArabicLogo.svg";
import Image from "next/image";
import { GiHamburgerMenu } from "react-icons/gi";
import { AiOutlineClose } from "react-icons/ai";
import { Link } from "react-scroll";
import Language from "./language";
import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";
import cookie from "js-cookie";
import Select from "./select";

function index() {
  const { t, i18n } = useTranslation();
  const router = useRouter();
  const { pathname, push } = useRouter();
  const [isOpen, setIsOpen] = useState(false);
  const handleLanguage = () => {
    if (i18n.language === "en") {
      return (
        i18n.changeLanguage("ar"),
        push(pathname, pathname, { locale: "ar" }),
        cookie.set("lang", "ar")
      );
    } else {
      return (
        i18n.changeLanguage("en"),
        push(pathname, pathname, { locale: "en" }),
        cookie.set("lang", "en")
      );
    }
  };

  return (
    <>
      <div className="p-5">
        <div className="flex items-center justify-between">
          <Image
            width="170.08"
            height="53.15"
            src={i18n.language === "en" ? Logo : ArabicLogo}
            alt="img"
          />
          <div className=" gap-2 lg:gap-5 xl:gap-7  text-[18px] font-bold text-white hidden xl:flex">
            <Link
              onClick={() => setIsOpen(false)}
              to="About"
              spy={true}
              href={"#"}
              smooth={true}
              className="cursor-pointer border-b-[1px] border-white "
            >
              {t("About")}
            </Link>

            <Link
              onClick={() => setIsOpen(false)}
              to="Services"
              spy={true}
              href={"#"}
              smooth={true}
              className="cursor-pointer hover:border-b-[1px] border-white "
            >
              {t("Services")}
            </Link>
            <Link
              onClick={() => setIsOpen(false)}
              to="UserInterface"
              spy={true}
              smooth={true}
              href={"#"}
              className="cursor-pointer hover:border-b-[1px] border-white "
            >
              {t("User Interface")}
            </Link>
            <Link
              onClick={() => setIsOpen(false)}
              to="WhatWeServe"
              spy={true}
              href={"#"}
              smooth={true}
              className="cursor-pointer hover:border-b-[1px] border-white "
            >
              {t("What we Serve")}
            </Link>

            <Select />
            <a
              className="cursor-pointer hover:border-b-[1px] border-white "
              onClick={() => setIsOpen(false)}
              href="/Agri-Tech/packages"
            >
              {t("Packages")}
            </a>
          </div>
          <div className="text-3xl block lg:hidden text-white bg-[#B3503A] rounded-lg p-2 bg-opacity-90 hover:bg-opacity-100 cursor-pointer">
            <GiHamburgerMenu onClick={() => setIsOpen(true)} />
          </div>
          <div className="items-center hidden gap-15 lg:flex">
            <Language />
            <div className=" bg-[#B3503A] px-5 py-1.5 bg-opacity-90 hover:bg-opacity-100 rounded-lg flex justify-center items-center cursor-pointer text-white font-bold text-[20px]">
              <div onClick={() => router.push("/auth/login")} className="-mt-1">
                {t("Log In")}
              </div>
            </div>
          </div>
        </div>
        <div
          className={`flex flex-col mt-20 text-center ${
            i18n.language === "en" ? "md:text-left" : "md:text-right"
          } md:mt-48 m-auto w-full h-full`}
        >
          <div className="m-auto">
            <div className="mb-2 text-3xl font-bold text-white md:text-6xl ">
              {t("All-in one digital farming solution")}
            </div>
            <div className="text-lg md:text-[1.35rem]  text-white ">
              {t(
                "Empowering Agribusiness with Real-Time Insights to enable smart crop management."
              )}
            </div>
            <div className="flex justify-center md:justify-start">
              <div className=" bg-white mt-10 w-[150px] px-5 py-1.5 bg-opacity-90 hover:bg-opacity-100 rounded-lg flex justify-center items-center cursor-pointer text-[#B3503A] font-bold text-[24px]">
                <Link
                  href={"#"}
                  to="ContactUs"
                  spy={true}
                  smooth={true}
                  className=""
                >
                  {t("Start Trial")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`fixed z-50	left-0 top-0 w-full h-full flex flex-col justify-center gap-5  items-center      font-bold bg-[#F7EDEB] duration-500 transform  ${
          isOpen ? "" : "-translate-y-full"
        }`}
      >
        <div
          onClick={() => setIsOpen(false)}
          className={`text-3xl fixed top-[20px] ${
            i18n.language === "en" ? "right-[20px]" : "left-[20px]"
          }  text-white bg-[#B3503A] rounded-lg p-2 bg-opacity-90 hover:bg-opacity-100 cursor-pointer`}
        >
          <AiOutlineClose />
        </div>
        {isOpen && (
          <>
            <Link
              onClick={() => setIsOpen(false)}
              to="About"
              href={"#"}
              spy={true}
              smooth={true}
              className="cursor-pointer hover:border-b-[1px] text-[35px]  border-black"
            >
              {t("About")}
            </Link>
            <Link
              onClick={() => setIsOpen(false)}
              to="Services"
              href={"#"}
              spy={true}
              smooth={true}
              className="cursor-pointer hover:border-b-[1px] text-[35px]  border-black"
            >
              {t("Services")}
            </Link>
            <Link
              onClick={() => setIsOpen(false)}
              to="UserInterface"
              href={"#"}
              spy={true}
              smooth={true}
              className="cursor-pointer hover:border-b-[1px] text-[35px]  border-black"
            >
              {t("User Interface")}
            </Link>
            <Link
              onClick={() => setIsOpen(false)}
              to="WhatWeServe"
              href={"#"}
              spy={true}
              smooth={true}
              className="cursor-pointer hover:border-b-[1px] text-[35px]  border-black"
            >
              {t("What we Serve")}
            </Link>

            <details className="cursor-pointer  text-[35px]  ">
              <summary>
                <div> {t("Resources")}</div>
              </summary>
              <p
                onClick={() => router.push("/Agri-Tech/blogs")}
                className="text-center cursor-pointer hover:border-b-[1px] text-[35px]  border-black"
              >
                {t("Blogs")}
              </p>
              <p
                onClick={() => router.push("/Agri-Tech/FAQ")}
                className="text-center cursor-pointer hover:border-b-[1px] text-[35px]  border-black"
              >
                {t("FAQ")}
              </p>
            </details>
            <a
              className="cursor-pointer hover:border-b-[1px] text-[35px]  border-black"
              onClick={() => setIsOpen(false)}
              href="/Agri-Tech/packages"
            >
              {t("Packages")}
            </a>

            <Link
              onClick={() => setIsOpen(false)}
              to="ContactUs"
              href={"#"}
              spy={true}
              smooth={true}
              className="cursor-pointer hover:border-b-[1px] text-[35px]  border-black"
            >
              {t("Contact Us")}
            </Link>
            <Link
              onClick={() => {
                setIsOpen(false);
                router.push("/auth/login");
              }}
              to="Contact Us"
              spy={true}
              smooth={true}
              href={"#"}
              className="cursor-pointer hover:border-b-[1px] text-[35px]  border-black"
            >
              {t("Log In")}
            </Link>
            <Link
              onClick={() => {
                setIsOpen(false);
                handleLanguage();
              }}
              to="Contact Us"
              spy={true}
              href={"#"}
              smooth={true}
              className="cursor-pointer hover:border-b-[1px] text-[35px]  border-black"
            >
              {i18n.language === "en" ? "العربية" : "English"}
            </Link>
          </>
        )}
      </div>
    </>
  );
}

export default index;
